<template>
  <button
    type="button"
    data-testid="TeacherTimerButton-toggle"
    class="teacher-tool-btn"
    :class="{ selected: timerStore.open }"
    @click="toggle"
  >
    <v-icon class="teacher-tool-icon">fa-light fa-alarm-clock</v-icon>
    <span class="teacher-tool-label">Laiks</span>
  </button>
</template>

<script lang="ts">
import { useAnnotationStore } from "~/stores/annotationStore"
import { useStudentWheelStore } from "~/stores/studentWheelStore"
import { useTeacherTimerStore } from "~/stores/teacherTimerStore"

export default {
  setup() {
    const annotationStore = useAnnotationStore()
    const studentWheelStore = useStudentWheelStore()
    const timerStore = useTeacherTimerStore()
    return { annotationStore, studentWheelStore, timerStore }
  },

  methods: {
    toggle() {
      if (this.timerStore.open) {
        this.timerStore.closeTimer()
        return
      }

      if (this.annotationStore.annotationMode && this.annotationStore.isGlobal) {
        this.annotationStore.toggleAnnotationMode()
      }
      this.studentWheelStore.setModalOpen(false)
      this.timerStore.openTimer()
    },
  },
}
</script>
